import { useNavigate } from "react-router";
import useFetch from "../../hooks/useFetch";

import { Accordion } from "react-bootstrap";
import { Link } from "react-router-dom";
import Permission from "../RoleManagement/Permission";

const Sasb = () => {
    const userdetails = JSON.parse(localStorage.getItem('userdetails'))
    const { data, isLoading } = useFetch(`sasb/company/${userdetails.company_id}`);
    const navigate = useNavigate();
    
    function formatDateToDayMonthYear(isoDate) {
        const date = new Date(isoDate);
        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        const day = String(date.getDate()).padStart(2, '0');
        const month = months[date.getMonth()];
        const year = date.getFullYear();
        
        return `${day} ${month} ${year}`;
    }

    const addNewSasb = () => {
        const routes = '/sasbform'
        navigate(routes);
    }

    const handleClick = (id, year) => {
        const routes = `/sasbform`;
        navigate(routes, { state: { id, year } });
    };

    if (isLoading) {
        return (
            <>
                <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4">
                    <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
                        <h1 className="h2"> <i className="fa-solid fa-spinner fa-spin"></i></h1>
                    </div>
                </main>
            </>
        )
    }

    return (
        <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4">
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom" >
                <div className="fixed-div">
                    <div className="h2">SASB Q & A</div>
                    <div className="buttons-right">
                        <Permission access={"/sasbform"}>
                            <Link to="/sasbform">
                                <button className="btn btn-primary btn-add" onClick={() => addNewSasb()}>
                                    Add New SASB
                                </button>
                            </Link>
                        </Permission>
                    </div>
                </div>
            </div>
            <br></br>

            <div>
                <table className="table">
                    <thead>
                        <tr>
                            <th>Id</th>
                            <th>Year</th>
                            <th>Created Date</th>
                        </tr>
                    </thead>
                    <tbody>
                        <>
                            {
                                data.data && data.data.length > 0 ? (
                                    data.data.map((curData, index) => {
                                        const { company_id, id, createdAt, year } = curData;

                                        return (
                                            <tr className='clickablerow'
                                                key={id}
                                                onClick={() => handleClick(company_id, year)}>
                                                <td>{index + 1}</td>
                                                <td>{year}</td>
                                                <td>{formatDateToDayMonthYear(createdAt)}</td>
                                            </tr>
                                        )
                                    })) : (
                                    <span>No SASB QnA reports available.</span>
                                )
                            }
                        </>
                    </tbody>
                </table>
            </div>
        </main>
    )
}

export default Sasb;